import { createRouter, createWebHashHistory } from 'vue-router';

// Any paths we define here must have matching location entries in nginx.
// See: ui/image/etc/nginx/conf.d/default.conf
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: "/:pathMatch(.*)",
    component: () => import('@/views/PathNotMatch.vue'),
    name: 'path-not-match'
  },
];

// So that we can detect the difference between 'no layout specified' and 'no
// route yet', make sure all the routes have a layout.
for (const route of routes) {
  route.meta        ||= { };
  route.meta.layout ||= 'DefaultLayout';
}

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
